import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import template from './PerformerSection.html?raw';
import { AddressWizardTypes as Types } from "../AddressWizardTypes";

import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import PerformerCard from './PerformerCard/PerformerCard';

interface ChangedCardsData {
    new: Array<PerformerCardChange>;
    changed: Array<PerformerCardChange>;
    deleted: Array<string>;
}
interface PerformerCardChange {
    ID: string;
    isNew: boolean;
    profession: string;
    isMainProfesion: boolean;
    memberInStoreData?: any;
    membersOfStoreData?: any;
}
class PerformerSection extends compose(_StatefulSection) {
    templateString: any = template;
    private contextEntityId;
    private addressType: "person" | "company";
    private tableLayouts;

    private performerCardList: HTMLElement;
    private changedCardsData: ChangedCardsData = { new: [], changed: [], deleted: [] };

    constructor(addressType: "person" | "company", contextEntityId?: string) {
        super(...(arguments as unknown as []));
        this.addressType = addressType;
        this.contextEntityId = contextEntityId;
    }

    private _onClick_NewPerformerCard() {

        this.setupPerformerCard(null, true);
    }

    private setupPerformerCard(performer = null, isNew = false) {

        let card = new PerformerCard(this.addressType);
        card.setup(this.performerCardList, this.tableLayouts, performer, isNew);
        card.on("DataChanged", lang.hitch(this, this.onCardDataChanged))
        card.on("deleted", lang.hitch(this, this.onCardDeleted))
        card.on("change_mainProfession", lang.hitch(this, this.onChangeMainProfession));
        this.on("change_mainProfession", lang.hitch(card, card.adjustMainProfession));
        if (isNew) {
            window.scrollTo({ top: card.domNode.offsetTop, behavior: "smooth" });
        }
    }

    setData(entityData: Types.PerformerData) {
        if (!entityData) return;

        this.entityId = entityData.ID;
        this.sourceData = lang.clone(entityData);
        this.tableLayouts = entityData.tableLayouts;
        super.setData.apply(this, arguments as any);
        // ###

        this.UiModder.domConstruct.empty(this.performerCardList);
        let list = entityData.EL_performers_address?.sort((a, b) => a.ref_ev_profession.description.localeCompare(b.ref_ev_profession.description));
        list = entityData.EL_performers_address?.sort((a, b) => (b.is_main_profession === true ? 1 : 0) - (a.is_main_profession === true ? 1 : 0))

        list?.forEach(performer => {
            this.setupPerformerCard(performer);
        });

        this.emit("DataUpdate", list?.length > 0)
    }

    private onChangeMainProfession(newMainId:string) {
        this.emit("change_mainProfession", newMainId);
    }

    private onCardDeleted(deletedId?: string) {

        if (deletedId) {
            this.changedCardsData.deleted.push(deletedId);

            let entry = this.changedCardsData.changed.filter(x => x.ID === deletedId)[0];
            if (entry) this.changedCardsData.changed.splice(this.changedCardsData.changed.indexOf(entry), 1);
        }

        this.emitDataChanged();
    }

    private onCardDataChanged(data: PerformerCardChange) {

        let mode = this.changedCardsData.changed;
        if (data.isNew === true) mode = this.changedCardsData.new;

        let entry = mode.filter(x => x.ID === data.ID)[0];
        if (entry) mode.splice(mode.indexOf(entry), 1, data);
        else mode.push(data);

        this.emitDataChanged();
    }

    private _onChangePseudonym(value) {
        this.setAttributeValue("pseudonym", value);

        this.emitDataChanged();
    }

    private emitDataChanged() {

        let data = {
            pseudonym: this.getAttributeValue("pseudonym"),
            changedCardsData: this.changedCardsData
        }
        console.debug(data);
        this.emit("DataChanged", data);
    }

    private loadPerformerData() {
        this.setStartupState("loading");
        this.hourGlassStart(this.domNode);

        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard__PerformerSection_GetData",
            { contextEntityId: this.contextEntityId },
            lang.hitch(this, this.onLoadPerformerDataResponse),
            lang.hitch(this, this._showErrorMessage)
        );
    }
    private onLoadPerformerDataResponse(response: Types.PerformerData) {

        this.setData(response);
        this.hourGlassEnd(this.domNode);
    }

    private _showErrorMessage(err?: more.requestErrorMessage | string) {
        let msg;
        this.hourGlassEnd(this.domNode);

        if (typeof err == "string") msg = err;
        else msg = err ? err.Message : "...error occured";

        this.showToast(msg, "fas fa-exclamation-triangle");
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.RequestManager.handleAs = "jsonWithDate";

        if (this.contextEntityId) this.loadPerformerData();
        else this.setStartupState("ready");
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PerformerSection);